import React, { Component } from 'react';

export class Examples extends Component {
  render() {
    return (
      <div>
        <h1>Examples</h1>
        <p>Coming soon...</p>
      </div>
    );
  }
}
